/**
 * Store Dossier
 */
export default {
    state: {
        lieuxCollectes: [],
        lyon: 1,
        ecf: 2,
        tunisie: 3,
        annecy: 4,
    },

    mutations: {
        /**
         * Initialise le state lieuxCollectes
         */
        setLieuxCollectes: function (state, lieuxCollectes) {
            state.lieuxCollectes = lieuxCollectes
        }
    },

    getters: {
        /**
         * Liste d'options de lieux de collectes
         */
        optionsLieuxCollectes: state => {
            return state.lieuxCollectes
                .filter(lieu => lieu.is_actif)
                .map(lieu => ({label: lieu.nom, value: lieu.id}))
        }
    }
}
